(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-bundle-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-product-bundle-banner]';

    const fallbackRates = {
      EUR: 1,
      PLN: 4.35,
      USD: 1.17,
      CAD: 1.62,
      GBP: 0.87,
    };

    const localizedBundleTotals = {
      EUR: { 3: 9700, 6: 19000 },
      PLN: { 3: 42500, 6: 83000 },
      USD: { 3: 10900, 6: 21000 },
      CAD: { 3: 15500, 6: 29900 },
      GBP: { 3: 8000, 6: 15900 },
    };

    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
          style: 'currency',
          currency: currency || 'EUR',
          currencyDisplay: 'symbol',
          maximumFractionDigits: 0,
        }).format(cents / 100);
      } catch (error) {
        return `${Math.round(cents / 100).toString().replace('.', ',')} ${currency || 'EUR'}`;
      }
    };

    const init = () => {
      document.querySelectorAll(`${selector}:not([data-initialized])`).forEach((root) => {
        root.dataset.initialized = 'true';

        const variantsElement = root.querySelector('[data-bundle-variants]');
        let variants = [];
        try {
          variants = JSON.parse(variantsElement?.textContent || '[]');
        } catch (error) {
          variants = [];
        }

        let optionNames = [];
        try {
          optionNames = JSON.parse(root.dataset.options || '[]');
        } catch (error) {
          optionNames = [];
        }

        const sizeKeywords = ['taglia', 'size', 'misura', 'taille', 'größe', 'groesse', 'talla', 'tamanho', 'rozmiar'];
        const colorKeywords = ['colore', 'color', 'colour', 'couleur', 'farbe', 'färg', 'cor', 'kolor'];
        const normalizedOptionNames = optionNames.map((name) => String(name || '').toLowerCase().trim());
        const detectedSizeIndex = normalizedOptionNames.findIndex((name) => sizeKeywords.some((keyword) => name.includes(keyword)));
        const detectedColorIndex = normalizedOptionNames.findIndex((name) => colorKeywords.some((keyword) => name.includes(keyword)));
        const optionIndexFromMarkup = Number(root.dataset.sizeOptionIndex);
        const sizeIndex = Number.isInteger(optionIndexFromMarkup) && optionIndexFromMarkup >= 0
          ? optionIndexFromMarkup
          : detectedSizeIndex >= 0
            ? detectedSizeIndex
            : detectedColorIndex === 0 && optionNames.length > 1
              ? 1
              : detectedColorIndex > 0
                ? 0
                : Math.max(optionNames.length - 1, 0);
        let currentVariant = variants.find((variant) => String(variant.id) === String(root.dataset.currentVariantId))
          || variants.find((variant) => variant.available)
          || variants[0];

        const getOptions = (variant) => [variant?.option1, variant?.option2, variant?.option3];
        const availableVariants = () => variants.filter((variant) => variant.available !== false);
        const sameContext = (variant) => {
          if (!currentVariant) return true;
          const currentOptions = getOptions(currentVariant);
          const variantOptions = getOptions(variant);
          return variantOptions.every((value, index) => index === sizeIndex || value === currentOptions[index]);
        };

        const contextVariants = () => {
          const matches = availableVariants().filter(sameContext);
          return matches.length ? matches : availableVariants();
        };

        const getVariantForSize = (size) => contextVariants().find((variant) => getOptions(variant)[sizeIndex] === size);

        const getCurrency = () => root.dataset.currency || window.Shopify?.currency?.active || root.dataset.baseCurrency || 'EUR';

        const getCurrencyRate = (currency) => {
          const baseCurrency = root.dataset.baseCurrency || 'EUR';
          if (currency === baseCurrency) return 1;
          const shopifyRate = Number(window.Shopify?.currency?.rate);
          if (Number.isFinite(shopifyRate) && shopifyRate > 0) return shopifyRate;
          return fallbackRates[currency] || 1;
        };

        const getDisplayTotalCents = (offer) => {
          const currency = getCurrency();
          const quantity = String(offer.dataset.quantity || 1);
          const localizedTotal = localizedBundleTotals[currency]?.[quantity];
          if (Number.isFinite(localizedTotal)) return localizedTotal;
          const baseTotal = Number(offer.dataset.totalCents || 0);
          return Math.round(baseTotal * getCurrencyRate(currency));
        };

        const updatePrice = (offer) => {
          const price = offer.querySelector('[data-bundle-price]');
          if (!price) return;
          const currency = getCurrency();
          price.textContent = formatMoney(getDisplayTotalCents(offer), currency);
        };

        const updateDiscount = (offer, variant) => {
          const discount = offer.querySelector('[data-bundle-discount]');
          if (!discount || !variant?.price) return;
          const quantity = Number(offer.dataset.quantity || 1);
          const totalCents = getDisplayTotalCents(offer);
          const regularCents = Number(variant.price) * quantity;
          const percentage = regularCents > totalCents ? Math.round((1 - totalCents / regularCents) * 100) : 0;
          discount.textContent = `${root.dataset.savingsLabel || 'Risparmi'} ${percentage}%`;
        };

        const updateOffer = (offer) => {
          const select = offer.querySelector('[data-bundle-size-select]');
          const button = offer.querySelector('[data-bundle-add]');
          const size = select?.value;
          const variant = getVariantForSize(size);
          if (button) {
            button.dataset.variantId = variant?.id || '';
            button.disabled = !variant || variant.available === false;
          }
          updateDiscount(offer, variant);
          updatePrice(offer);
        };

        const closeOffer = (offer) => {
          offer.classList.remove('is-selected');
          offer.querySelector('[data-bundle-choice]')?.setAttribute('aria-expanded', 'false');
          const details = offer.querySelector('[data-bundle-details]');
          if (details) details.hidden = true;
        };

        const openOffer = (offer) => {
          root.querySelectorAll('[data-bundle-offer]').forEach((otherOffer) => {
            if (otherOffer !== offer) closeOffer(otherOffer);
          });
          offer.classList.add('is-selected');
          offer.querySelector('[data-bundle-choice]')?.setAttribute('aria-expanded', 'true');
          const details = offer.querySelector('[data-bundle-details]');
          if (details) details.hidden = false;
          updateOffer(offer);
          window.setTimeout(() => offer.querySelector('[data-bundle-size-select]')?.focus(), 0);
        };

        const populateSizes = () => {
          const sizes = [];
          contextVariants().forEach((variant) => {
            const size = getOptions(variant)[sizeIndex];
            if (size && !sizes.includes(size)) sizes.push(size);
          });

          root.querySelectorAll('[data-bundle-size-select]').forEach((select) => {
            const previousValue = select.value;
            select.innerHTML = `<option value="">${root.dataset.selectLabel || 'Seleziona taglia'}</option>`;
            sizes.forEach((size) => {
              const option = document.createElement('option');
              option.value = size;
              option.textContent = size;
              select.appendChild(option);
            });
            const currentSize = getOptions(currentVariant)[sizeIndex];
            select.value = sizes.includes(previousValue) ? previousValue : (sizes.includes(currentSize) ? currentSize : '');
          });

          root.querySelectorAll('[data-bundle-offer]').forEach(updateOffer);
          root.querySelectorAll('[data-bundle-offer]').forEach(updatePrice);
        };

        const addBundle = async (button) => {
          const offer = button.closest('[data-bundle-offer]');
          const select = offer?.querySelector('[data-bundle-size-select]');
          const variantId = button.dataset.variantId;
          const size = select?.value;
          if (!offer || !variantId || !size) return;

          const originalLabel = button.textContent;
          const quantity = Number(offer.dataset.quantity || 1);
          button.disabled = true;
          button.textContent = root.dataset.loadingLabel || 'Aggiunta…';

          try {
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: Number(variantId),
                  quantity,
                  properties: { _Bundle: `${quantity}x`, _Taglia: size },
                }],
              }),
            });
            if (!response.ok) throw new Error('cart-add-failed');

            const cartResponse = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: root.id, data: { source: root.id, itemCount: cart.item_count, variantId } },
            }));
            document.querySelector('cart-drawer, cart-drawer-component')?.open?.();
            button.textContent = root.dataset.addedLabel || 'Aggiunto';
            window.setTimeout(() => {
              button.textContent = originalLabel;
              button.disabled = false;
            }, 1200);
          } catch (error) {
            button.textContent = originalLabel;
            button.disabled = false;
            const status = offer.querySelector('[data-bundle-status]');
            if (status) status.textContent = root.dataset.errorLabel || 'Riprova tra poco.';
          }
        };

        root.querySelectorAll('[data-bundle-choice]').forEach((choice) => choice.addEventListener('click', () => openOffer(choice.closest('[data-bundle-offer]'))));
        root.querySelectorAll('[data-bundle-size-select]').forEach((select) => select.addEventListener('change', () => updateOffer(select.closest('[data-bundle-offer]'))));
        root.querySelectorAll('[data-bundle-add]').forEach((button) => button.addEventListener('click', () => addBundle(button)));
        root.querySelectorAll('[data-bundle-offer]').forEach(closeOffer);
        populateSizes();

        document.addEventListener('variant:update', (event) => {
          const variantId = event.detail?.resource?.id;
          if (!variantId) return;
          currentVariant = variants.find((variant) => String(variant.id) === String(variantId)) || currentVariant;
          populateSizes();
        });

        document.addEventListener('currency:change', () => {
          root.querySelectorAll('[data-bundle-offer]').forEach(updatePrice);
        });
      });
    };

    init();
    document.addEventListener('variant:update', () => window.setTimeout(init, 0));
    new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
